module.exports = __webpack_public_path__ + "static/media/5_My RSVPs.9dd9674a.jpg";